import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/companys/ttl/assets/styles/components/position-proportion/position-proportion-dialog.scss'
import china from '@/assets/images/icons/bottom_icon_China.png'
import hk from '@/assets/images/icons/bottom_icon_hk.png'
import us from '@/assets/images/icons/english.png'
import viet from '@/assets/images/icons/viet.png'
import up from '@/assets/images/icons/up.png'
import down from '@/assets/images/icons/down.png'

import PositionProportionEChart from './PositionProportionEChart';
import { getSafe } from '@/helpers/global';
import classnames from 'classnames';

class PositionProportionDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: [
                { nationalIcon: hk, market: 'account_Proportion_hk', totalMarketValue: 0, detailData: [] },
                { nationalIcon: china, market: 'account_Proportion_sh', totalMarketValue: 0, detailData: [] },
                { nationalIcon: china, market: 'account_Proportion_sz', totalMarketValue: 0, detailData: [] },
                { nationalIcon: us, market: 'account_Proportion_us', totalMarketValue: 0, detailData: [] },
                // { nationalIcon: viet, market: 'account_Proportion_vn', totalMarketValue: 0, detailData: [] },
            ],
            marketValueDataList: null,
            detailDataIndex: 0,
            stockTotalProportion: 0,
            legend: [
                {
                    name: this.props.language.market_position_proportion_holdings,
                    selectedMode: false,
                    itemWidth: 0,
                    itemHeight: 0,
                    top:'64%',
                    left: '7%',
                    data: [  {name:this.props.language.market_position_proportion_holdings}],
                    textStyle: {
                        color: this.props.theme == 'light' ? '#000' : '#fff',
                        fontSize: 14
                    }
                },
                {   type:'scroll',
                    orient: 'vertical',
                    top:'70%',
                    left: '7%',
                    selectedMode: false,
                    textStyle: {
                        color: this.props.theme == 'light' ? '#000' : '#fff'
                    }

                }],
                tooltip:{
                    trigger: 'item',
                    position:function(point,params,dom,rect,size){
                        return [point[0],point[1]]
                    }
                }
        }
    }
    render() {
        const { language } = this.props
        const { formData, detailDataIndex, stockTotalProportion, marketValueDataList, legend,tooltip } = this.state
        return (
            <div className='position-proportion-dialog' >
                <div className='ppd-erchart'>
                    <PositionProportionEChart
                        innerRef={e => this.PositionProportionEChartRef = e}
                        data={marketValueDataList}
                        legend={legend}
                        top={-170}
                        radius={['28%', '40%']}
                        tooltip={tooltip}
                        labelLine={{show:true}}
                    ></PositionProportionEChart>
                </div>
                <div className='ppd-form' >
                    <div className='ppd-form-head'>
                        <span className='ppd-form-head-market' >{language.common_market}</span>
                        <span className='ppd-form-head-market-value'>{language.account_market_value}</span>
                        <span className='ppd-form-head-proportion' >{language.market_position_proportion_proportion}</span>
                    </div>
                    <div className='ppd-form-data'>
                        {formData.map((item, index) => {
                            return (
                                <div key={index} >
                                    <div className='ppd-form-data-single' onClick={() => this.handleDetailDataDiv(index)} >
                                        <div className='ppd-form-data-one-market' ><img src={item.nationalIcon} /> {language[item.market]} </div>
                                        <span className='ppd-form-data-one-market-value'>{(item.totalMarketValue).toLocaleString(undefined,{'minimumFractionDigits':2,'maximumFractionDigits':2})}</span>
                                        <span className='ppd-form-data-one-proportion'>{this.handleProportion(item.totalMarketValue, stockTotalProportion)} </span>
                                        <div className='ppd-form-data-one-img' >
                                            <img src={detailDataIndex == index ? down : up}  />
                                        </div>
                                    </div>
                                    <div className={classnames('ppd-form-detail-data', detailDataIndex == index ? 'open' : 'close')}
                                        style={{
                                            overflowY: item.detailData.length <= 8 ? 'null' : 'scroll',
                                            height: detailDataIndex == index ? item.detailData.length <= 8 ? (item.detailData.length * 50) + 'px' : '400px' : '0px'
                                        }}
                                        key={index} >
                                        {item.detailData.map((ditem, dindex) => {
                                            return (
                                                <div className='ppd-form-detail-data-single' key={dindex} >
                                                    <div className='ppd-fdds-market'>
                                                        <div>{ditem.stock}</div>
                                                        <div>{ditem.name}</div>
                                                    </div>
                                                    <div className='ppd-fdds-market-value' >
                                                        {Number(ditem.value).toLocaleString(undefined,{'minimumFractionDigits':2,'maximumFractionDigits':2})}
                                                    </div>
                                                    <div className='ppd-fdds-proportion'>{this.handleProportion(ditem.value, stockTotalProportion)}</div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
    componentDidMount() {
        this.formatData()
        this.getData()
    }
    handleProportion = (x, y) => {
        if (x != 0) {
            let res = (Number(x) / y * 100)
            return res.toFixed(2) + '%'
        } else {
            return 0
        }
    }
    handleDetailDataDiv = (index) => {
        switch (index) {
            default:
                if (index == this.state.detailDataIndex) {
                    this.setState({ detailDataIndex: null })
                } else {
                    this.setState({ detailDataIndex: index })
                }
        }
    }
    formatDataCase = (index, item, stockName) => {
        const { language } = this.props
        let { formData } = this.state
        let stock = ''
        let name = ''
        let value = ''
        let proportion = 0
        formData[index].totalMarketValue += Number(item.marketValueClientBase)
        stock = stockName + item.stockCode
        if (language.lang === "en_US") {
            name = item.stockShortName;
        } else {
            name = item.stockChineseShortName;
        }
        value = item.marketValueClientBase
        formData[index].detailData.push({ stock, name, value, proportion })
        this.setState({ formData }, () => {
        })
        return Number(item.marketValueClientBase)
    }
    formatData = () => {
        const { portfolios } = this.props
        let portfoliosList = portfolios.portfoliosList
        let sum = 0
        portfoliosList?.map((item, index) => {
            if (item.marketValueClientBase == 0) return
            switch (item.marketID) {
                case 'HKEX':
                    sum += this.formatDataCase(0, item, 'HK.')
                    break;
                case 'MAMK':
                    sum += this.formatDataCase(1, item, 'SH.')
                    break;
                case 'SZMK':
                    sum += this.formatDataCase(2, item, 'SZ.')
                    break;
                case 'USEX':
                    sum += this.formatDataCase(3, item, 'US.')
                    break;
            }
            this.setState({ stockTotalProportion: sum })
        })

    }
    getData = () => {
        const { portfolios, language } = this.props;
        if (portfolios.portfoliosList) {
            let marketValueDataList = [];
            const portfoliosList = portfolios.portfoliosList;
            portfoliosList.map(item => {
                let marketValueData = {};
                if (language.lang === "en_US") {
                    marketValueData.name = item.stockShortName;
                } else {
                    marketValueData.name = item.stockChineseShortName;
                }
                if (item.marketValueClientBase === '0') {
                    marketValueData.label = {
                        normal: {
                            show: false
                        }
                    }
                    return
                }
                marketValueData.value = item.marketValueClientBase;
                marketValueDataList.push(marketValueData);
            })
            this.setState({
                marketValueDataList: marketValueDataList,
            }, () => {
                if (marketValueDataList && this.PositionProportionEChartRef) {
                    this.PositionProportionEChartRef.setEChartPieData({
                        series: [{
                            data: marketValueDataList
                        }]
                    })
                }
            })
        }

    }
}



export default connect(state => ({
    language: state.app.language,
    portfolios: state.trade.portfolios,
    theme: state.app.theme,
}),
    dispatch => ({

    }))(PositionProportionDialog)